/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getAddressDecoder,
  getAddressEncoder,
  getArrayDecoder,
  getArrayEncoder,
  getOptionDecoder,
  getOptionEncoder,
  getStructDecoder,
  getStructEncoder,
  getU128Decoder,
  getU128Encoder,
  getU16Decoder,
  getU16Encoder,
  getU64Decoder,
  getU64Encoder,
  type Address,
  type Codec,
  type Decoder,
  type Encoder,
  type Option,
  type OptionOrNullable,
} from '@solana/kit';
import {
  getMigratedPoolHookConfigDecoder,
  getMigratedPoolHookConfigEncoder,
  getRecipientDecoder,
  getRecipientEncoder,
  type MigratedPoolHookConfig,
  type MigratedPoolHookConfigArgs,
  type Recipient,
  type RecipientArgs,
} from '.';

/**
 * Arguments for register_launch instruction.
 * These are deserialized from the migrator_init_payload passed by initializer.
 */
export type RegisterLaunchArgs = {
  cpmmConfig: Address;
  initialSwapFeeBps: number;
  initialFeeSplitBps: number;
  recipients: Array<Recipient>;
  minRaiseQuote: bigint;
  minMigrationPriceQ64Opt: Option<bigint>;
  migratedPoolHookConfig: Option<MigratedPoolHookConfig>;
};

export type RegisterLaunchArgsArgs = {
  cpmmConfig: Address;
  initialSwapFeeBps: number;
  initialFeeSplitBps: number;
  recipients: Array<RecipientArgs>;
  minRaiseQuote: number | bigint;
  minMigrationPriceQ64Opt: OptionOrNullable<number | bigint>;
  migratedPoolHookConfig: OptionOrNullable<MigratedPoolHookConfigArgs>;
};

export function getRegisterLaunchArgsEncoder(): Encoder<RegisterLaunchArgsArgs> {
  return getStructEncoder([
    ['cpmmConfig', getAddressEncoder()],
    ['initialSwapFeeBps', getU16Encoder()],
    ['initialFeeSplitBps', getU16Encoder()],
    ['recipients', getArrayEncoder(getRecipientEncoder())],
    ['minRaiseQuote', getU64Encoder()],
    ['minMigrationPriceQ64Opt', getOptionEncoder(getU128Encoder())],
    [
      'migratedPoolHookConfig',
      getOptionEncoder(getMigratedPoolHookConfigEncoder()),
    ],
  ]);
}

export function getRegisterLaunchArgsDecoder(): Decoder<RegisterLaunchArgs> {
  return getStructDecoder([
    ['cpmmConfig', getAddressDecoder()],
    ['initialSwapFeeBps', getU16Decoder()],
    ['initialFeeSplitBps', getU16Decoder()],
    ['recipients', getArrayDecoder(getRecipientDecoder())],
    ['minRaiseQuote', getU64Decoder()],
    ['minMigrationPriceQ64Opt', getOptionDecoder(getU128Decoder())],
    [
      'migratedPoolHookConfig',
      getOptionDecoder(getMigratedPoolHookConfigDecoder()),
    ],
  ]);
}

export function getRegisterLaunchArgsCodec(): Codec<
  RegisterLaunchArgsArgs,
  RegisterLaunchArgs
> {
  return combineCodec(
    getRegisterLaunchArgsEncoder(),
    getRegisterLaunchArgsDecoder(),
  );
}
